import { Scale, CheckCircle2, AlertTriangle, FileText } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-8 font-body">
      <div className="border-b border-border pb-6 space-y-2">
        <span className="text-xs font-mono uppercase tracking-[0.2em] text-primary font-semibold">Terms of Service</span>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-slate-900">Terms & Conditions</h1>
        <p className="text-slate-500 text-sm">Last updated: August 2026</p>
      </div>

      <div className="bg-card border border-border rounded-3xl p-8 sm:p-10 space-y-6 text-slate-700 leading-relaxed text-sm sm:text-base shadow-sm">
        <section className="space-y-2">
          <h2 className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
            <Scale className="w-5 h-5 text-primary" /> 1. Service Agreement
          </h2>
          <p>
            By using Tablezy or registering your restaurant for a QR digital menu, you agree to these Terms & Conditions. Tablezy provides digital menu hosting, QR code generation, and administrative control tools for food and beverage merchants.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5 text-primary" /> 2. Merchant Responsibilities
          </h2>
          <p>
            Cafe and restaurant owners are responsible for ensuring that menu items, prices, descriptions, allergen indicators (Veg/Non-Veg), and tax information displayed on their Tablezy digital menu are accurate and up to date.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
            <FileText className="w-5 h-5 text-primary" /> 3. Intellectual Property
          </h2>
          <p>
            Merchants retain ownership of their uploaded restaurant logos, brand images, and custom menu text. Tablezy retains ownership of the underlying software platform, QR code generation design, and digital menu templates.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-primary" /> 4. Service Availability & Support
          </h2>
          <p>
            We strive to maintain 99.9% platform uptime for all QR digital menus. Technical support is provided via our dedicated helpline and support ticket desk during operating business hours.
          </p>
        </section>
      </div>
    </div>
  );
}
